import { render, staticRenderFns } from "./StudentDismissalCategory.vue?vue&type=template&id=23b1d538&scoped=true"
import script from "./StudentDismissalCategory.vue?vue&type=script&lang=js"
export * from "./StudentDismissalCategory.vue?vue&type=script&lang=js"
import style0 from "./StudentDismissalCategory.vue?vue&type=style&index=0&id=23b1d538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b1d538",
  null
  
)

export default component.exports